import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close'
import { Base } from '@itsrever/design-system'
import { useAnalyticsFilters } from '@/application/queries'
import { useSessionFilters } from '@/application/use-session-filters'
import {
  isDashboardBlocked,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { BlockedDashboardOverlay } from '@/ui/components/overlays/blocked-dashboard-overlay'
import { Filter } from './filter'
import { PortalSelector } from './portal-selector'

const { IconButton } = Base

interface AnalyticsFilterBarProps {
  startDate: string | undefined
  endDate: string | undefined
  // Filter names the page cannot apply.
  exclude?: string[]
  className?: string
}

export function AnalyticsFilterBar({
  startDate,
  endDate,
  exclude = [],
  className
}: AnalyticsFilterBarProps) {
  const { t } = useTranslation()
  const { isFlagEnabled } = useFeatureFlag(isDashboardBlocked, {
    pageName: 'analytics'
  })
  const { loadingPreviousFilters, sessionFilters, clearSessionFilters } =
    useSessionFilters()
  const { filters, loadingFilters } = useAnalyticsFilters(startDate, endDate)

  return (
    <>
      {isFlagEnabled && <BlockedDashboardOverlay />}
      <div className={clsx('flex items-center gap-2', className)}>
        <PortalSelector />
        {loadingFilters || loadingPreviousFilters
          ? null
          : filters.map((f) => {
              const name = Object.keys(f)[0]
              return exclude.includes(name) ? null : (
                <Filter key={name} name={name} options={f[name]} />
              )
            })}
        {sessionFilters ? (
          <IconButton
            size="sm"
            aria-label={t('filter.clear_all')}
            onClick={clearSessionFilters}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </div>
    </>
  )
}
